import React, { useState, useMemo, useContext, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ReactDataTables from "../../customComponents/ReactDataTables";
import { DataTableLoader } from "../../utils/Loader";
import { Modal } from "reactstrap";
import { CompanyContext, AuthContext } from "../../utils/CompanyContext";
import { getAllUrlParams } from "../../utils/urlParams";
import { FormatDate, FormatDateFormat } from "../../utils/dateFormat";
import {
  getMyEvaluationESIIHistoryData,
  myEvaluationESIIHistoryDetailsReact,
} from "../../store/actions";
import EvaluationScreen from "./EvaluationScreen";
import SearchDropdown from "../../customComponents/SearchDropdown";

function MyEvaluation() {
  const dispatch = useDispatch();
  const { CGUID, Loginid, LoginEmail, loginemptitle } = useContext(AuthContext);
  const [appliedSearch, setAppliedSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const myEvaluationHistory = useSelector(
    (state) => state.get_my_evaluation_esii_history_data.data || [],
  );
  const isFetchingList = useSelector(
    (state) => state.get_my_evaluation_esii_history_data.isFetching,
  );
  const activityHistoryAllInfo = useSelector(
    (state) => state.my_evaluation_esiihistory_details_react.data || [],
  );

  const isFetching = useSelector(
    (state) => state.my_evaluation_esiihistory_details_react.isFetching,
  );

  const evalDetailsModal = (rowItem) => {
    toggleModal();
    dispatch(
      myEvaluationESIIHistoryDetailsReact({
        companyguid: CGUID,
        organization: rowItem.organization,
        formid: rowItem?.formid,
        evaluationid: rowItem?.evaluationid,
        loginemptitle: loginemptitle,
        loogedinuser: LoginEmail,
      }),
    );
  };
  const toggleModal = () => {
    setShowModal((prev) => !prev);
  };
  useEffect(() => {
    const fetchData = () => {
      dispatch(
        getMyEvaluationESIIHistoryData({
          companyguid: CGUID,
          evaluatedto: Loginid,
        }),
      );
    };
    fetchData();
  }, [CGUID, Loginid, dispatch]);

  const columns = [
    {
      title: "Evaluation ID",
      data: "evaluationid",
      render: function (data, type, row) {
        return `<span class="row-click row-click-evalhistory">${data}</span>`;
      },
      onClick: (rowData, colIndex) => evalDetailsModal(rowData),
    },
    {
      title: "Organization",
      data: "organization",
    },
    {
      title: "Program",
      data: "programname",
    },
    {
      title: "Evaluation Form",
      data: "formname",
    },
    {
      title: "Date",
      data: "evaluationcreateddate",
      render: (data, type, row) => {
        return `<span class="d-none">${FormatDateFormat(
          data,
          "YYYYMMDD",
        )}</span> ${FormatDate(data)}`;
      },
    },
    {
      title: "Evaluated By",
      data: "evaluatedby",
      render: function (data, type, row) {
        return data
          ? `<span class="">${row.evaluated_by_fname} ${row.evaluated_by_lname}</span>`
          : "";
      },
    },
    {
      title: "Supervisor",
      data: "managername",
    },
    {
      title: "Type of Scoring",
      data: "typeofscoring",
    },
    {
      title: "Goal",
      data: "goal",
    },
    {
      title: "Form Score",
      data: "totalpointscored",
    },
    {
      title: "Form Points Possible",
      data: "typeofscoring",
      render: function (data, type, row) {
        return `<span class="">${row.typeofscoring == "average" ? "N/A" : row.maxpoints}</span>`;
      },
    },
    {
      title: `<img className="coaching_history_image col-header-img" src="/images/thumbs_up.svg" />`,
      data: "ack",
      sortable: false,
      render: (data, type, row) => {
        return data
          ? '<img className="coaching_history_image" src="/images/thumbs_up.svg" />'
          : "";
      },
    },
  ];
  const evaluatedByList = useMemo(() => {
    if (!myEvaluationHistory?.length) return [];

    const names = myEvaluationHistory.map((x) =>
      `${x.evaluated_by_fname || ""} ${x.evaluated_by_lname || ""}`.trim(),
    );

    return [...new Set(names)].filter(Boolean);
  }, [myEvaluationHistory]);

  const filteredData = useMemo(() => {
    if (!appliedSearch) return myEvaluationHistory;
    const searchValue = appliedSearch.trim().toLowerCase();

    return myEvaluationHistory.filter((item) => {
      const fullName =
        `${item.evaluated_by_fname || ""} ${item.evaluated_by_lname || ""}`
          .trim()
          .toLowerCase();

      return fullName === searchValue;
    });
  }, [appliedSearch, myEvaluationHistory]);

  return (
    <div className="my-evalution">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="top_bar d-flex justify-content-end align-items-center">
              <SearchDropdown
                data={evaluatedByList}
                placeholder="Search for Evaluated By."
                onSelect={(value) => {
                  setAppliedSearch(value);
                }}
              />
            </div>
            <div className="" id="coaching_history">
              <div className="row">
                <div className="col-md-12">
                  <div className="coach_comparision1">
                    <div className="header_with_border">
                      <h3>Evaluation History</h3>
                    </div>
                    <div
                      className="agent_coaching_history"
                      id="coachingHistory_wrapper"
                    >
                      {isFetchingList ? (
                        <div className="text-center">
                          <DataTableLoader />
                        </div>
                      ) : (
                        <ReactDataTables
                          data={filteredData}
                          columns={columns}
                          defaultSort={{ columnIndex: 0, direction: "desc" }}
                          paging={false}
                          scrollY="75vh"
                          className="pt-2"
                          fixedHeader={true}
                          responsive={false}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <Modal
          isOpen={showModal}
          toggle={toggleModal}
          backdrop={true}
          keyboard={true}
          id="viewcoach"
          style={{
            maxWidth: "90%",
          }}
        >
          <EvaluationScreen
            dashboard="ESII"
            activityHistoryAllInfo={activityHistoryAllInfo}
            isFetching={isFetching}
            toggleModal={toggleModal}
          />
        </Modal>
      )}
    </div>
  );
}

export default MyEvaluation;
